import { useSelector } from "react-redux";
import { isMerchantScoped, isReadOnly } from "../../../constants/roles";

/**
 * The merchant the page acts on: a merchant-scoped login's own, otherwise the header dropdown.
 * Same rule as Receipt Layout and the Media library.
 */
export default function useSelectedMerchant() {
  const userType = localStorage.getItem("userType");
  const { selectedMerchant: reduxSelectedMerchant } = useSelector((state) => state.merchant || {});
  const merchantId = isMerchantScoped(userType) ? localStorage.getItem("MerchantId") : reduxSelectedMerchant;
  const hasMerchant = !!merchantId && merchantId !== "all";
  return {
    userType,
    merchantId: hasMerchant ? merchantId : null,
    hasMerchant,
    isAdmin: userType === "admin",
    readOnly: isReadOnly(userType),
  };
}
